import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-stone-800 text-stone-200">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <img
              src="https://static.readdy.ai/image/592edeeb72878c36421bcef1375eb795/9c4b53bfbf9e4bb8ddd64331f1647f4c.png"
              alt="Florida Homes for Sale"
              className="h-14 w-auto object-contain mb-4 brightness-150"
            />
            <p className="text-stone-400 text-sm leading-relaxed">
              Your trusted Florida real estate expert. Helping families find their dream homes across the Sunshine State.
            </p>
            <div className="flex gap-4 mt-6">
              <a href="#" aria-label="Facebook" className="w-9 h-9 flex items-center justify-center rounded-full border border-stone-600 hover:border-amber-500 hover:text-amber-500 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-sm"></i>
              </a>
              <a href="#" aria-label="Instagram" className="w-9 h-9 flex items-center justify-center rounded-full border border-stone-600 hover:border-amber-500 hover:text-amber-500 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a href="#" aria-label="LinkedIn" className="w-9 h-9 flex items-center justify-center rounded-full border border-stone-600 hover:border-amber-500 hover:text-amber-500 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-sm"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold uppercase tracking-widest text-xs mb-6">
              <a href="#quick-links">Quick Links</a>
            </h4>
            <ul className="space-y-3">
              {[
                { label: 'Home', path: '/' },
                { label: 'Listings', path: '/listings' },
                { label: 'About Amparo', path: '/about' },
                { label: 'Contact', path: '/contact' },
                { label: 'Request Information', path: '/request' },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-stone-400 text-sm hover:text-amber-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold uppercase tracking-widest text-xs mb-6">
              <a href="#contact-info">Contact</a>
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-stone-400 text-sm">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-amber-500"></i>
                </div>
                <span>West Palm Beach Florida 33406<br />Serving All of Florida</span>
              </li>
              <li className="flex items-center gap-3 text-stone-400 text-sm">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-amber-500"></i>
                </div>
                <a href="tel:+13055550192" className="hover:text-amber-400 transition-colors">(772) 626-8544</a>
              </li>
              <li className="flex items-center gap-3 text-stone-400 text-sm">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-amber-500"></i>
                </div>
                <a href="mailto:psluice369@gmail.com" className="hover:text-amber-400 transition-colors">psluice369@gmail.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-stone-700 mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-stone-500 text-sm">&copy; 2026 Florida Homes for Sale. All rights reserved.</p>
          <p className="text-stone-500 text-sm">Amparo Jarquin | Licensed Real Estate Agent</p>
        </div>
      </div>
    </footer>
  );
}
